import {createContext} from "react";
import type {Notification, NotificationVariant} from "./types";

type NotificationContextValue = {
  notifications: Notification[];
  addNotification: (message: string, variant: NotificationVariant) => string;
  removeNotification: (id: string) => void;
};

export const NotificationContext = createContext<
  NotificationContextValue | undefined
>(undefined);
